import { addMonths } from 'date-fns';

const MIGRATION_DURATION_IN_MONTHS = 3;

const getEstimatedEPMigrationEndDate = (migratedToEPAt: string) =>
  addMonths(new Date(migratedToEPAt), MIGRATION_DURATION_IN_MONTHS);

export default getEstimatedEPMigrationEndDate;
